import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function digitsOnly(value: string) {
  return value.replace(/\D/g, "");
}

export function formatThousands(value: string) {
  return value ? Number(value).toLocaleString("id-ID") : "";
}

/**
 * Format mata uang Rupiah dengan mempertahankan desimal bermakna hingga 4 digit di belakang koma.
 * Digunakan untuk biaya satuan (unit cost/HPP per gram, mL, atau cup).
 */
export function formatCurrency(value: number | string | null | undefined) {
  return `Rp ${Number(value || 0).toLocaleString("id-ID", {
    maximumFractionDigits: 4,
  })}`;
}

/**
 * Format mata uang Rupiah bulat tanpa desimal (integer Rupiah half-up).
 * Digunakan untuk subtotal dan total biaya di halaman produksi/transaksi.
 */
export function formatCurrencyRounded(
  value: number | string | null | undefined,
) {
  const rounded = Math.round(Number(value || 0));
  const safeRounded = rounded === 0 ? 0 : rounded;
  return `Rp ${safeRounded.toLocaleString("id-ID")}`;
}

export { formatPhone, normalizePhoneDigits } from "@artisancode/phone";
